import { c as _c } from "react/compiler-runtime";
import { PassengerRoomCountTourPropertiesType } from "@website/accommodation-ui/tour-search-wrapper/tour-search-panel/passenger-room-count-input/passenger-room-count-tour/types";
import { useAddRemoveQuery } from "@website/hooks/add-remove-query";
import { useViewPort } from "@website/hooks/viewport";
import { ArrowDropDown } from "@website/icons/components/arrow-drop-down";
import { CounterButton } from "@website/ui/counter-button";
import pick from "lodash-es/pick";
import { useRouter } from "next/router";
export const usePassengerRoomCountTour = properties => {
  const $ = _c(37);
  const {
    onSubmit,
    list,
    title,
    result,
    onChange,
    onClosePassengerButton,
    chipsColor,
    iconColor,
    PopoverClassName
  } = properties;
  const router = useRouter();
  const {
    removeQuery
  } = useAddRemoveQuery("SEARCH_INT_HOTEL_PASSENGER_COUNT");
  const open = router.query.SEARCH_INT_HOTEL_PASSENGER_COUNT ? Boolean(router.query.SEARCH_INT_HOTEL_PASSENGER_COUNT) : false;
  const {
    isDesktop
  } = useViewPort();
  let t0;
  if ($[0] !== isDesktop || $[1] !== router) {
    t0 = () => {
      const parameters = isDesktop ? {
        SEARCH_INT_HOTEL_PASSENGER_COUNT: true
      } : {
        OPEN_SEARCH: true,
        SEARCH_INT_HOTEL_PASSENGER_COUNT: true
      };
      router.replace({
        pathname: router.pathname,
        query: {
          ...router.query,
          ...parameters
        }
      });
    };
    $[0] = isDesktop;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onClickChips = t0;
  let t1;
  if ($[3] !== removeQuery) {
    t1 = () => {
      removeQuery();
    };
    $[3] = removeQuery;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onClosePopover = t1;
  let t2;
  if ($[5] !== onClosePopover || $[6] !== onSubmit) {
    t2 = () => {
      onSubmit(onClosePopover);
    };
    $[5] = onClosePopover;
    $[6] = onSubmit;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onClickSubmit = t2;
  let t3;
  if ($[8] !== onClosePassengerButton || $[9] !== onClosePopover) {
    t3 = () => {
      onClosePopover();
      onClosePassengerButton && onClosePassengerButton();
    };
    $[8] = onClosePassengerButton;
    $[9] = onClosePopover;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onCloseButton = t3;
  let t4;
  if ($[11] !== onClickSubmit) {
    t4 = {
      onClick: onClickSubmit,
      color: "secondary" as const,
      size: "large" as const,
      fullWidth: true
    };
    $[11] = onClickSubmit;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = `${iconColor ?? "#575eff"}`;
  let t6;
  if ($[13] !== t5) {
    t6 = <ArrowDropDown fill={t5} />;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = chipsColor || "secondary" as const;
  let t8;
  if ($[15] !== onClickChips || $[16] !== result || $[17] !== t6 || $[18] !== t7) {
    t8 = {
      variant: "outline" as const,
      EndIcon: t6,
      text: result,
      selected: true,
      color: t7,
      onClick: onClickChips,
      className: ""
    };
    $[15] = onClickChips;
    $[16] = result;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== PopoverClassName || $[21] !== onCloseButton || $[22] !== onClosePopover || $[23] !== open || $[24] !== title) {
    t9 = {
      onClose: onClosePopover,
      open,
      title,
      onCloseButton,
      className: PopoverClassName
    };
    $[20] = PopoverClassName;
    $[21] = onCloseButton;
    $[22] = onClosePopover;
    $[23] = open;
    $[24] = title;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== list || $[27] !== onChange) {
    let t11;
    if ($[29] !== onChange) {
      t11 = (items, itemsIndex) => ({
        ...items,
        children: items.children.map((item, itemIndex) => ({
          title: item.title,
          subtitle: item.subtitle,
          role: "default",
          EndAction: <CounterButton aria-label={item.title} color="secondary" onChange={value => onChange(value, itemsIndex, itemIndex)} variant="outline" {...pick(item, "decreaseDisabled", "increaseDisabled")} locale="fa" value={item?.value?.length} />
        }))
      });
      $[29] = onChange;
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    t10 = list.map(t11);
    $[26] = list;
    $[27] = onChange;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[31] !== onChange || $[32] !== t10 || $[33] !== t4 || $[34] !== t8 || $[35] !== t9) {
    t11 = {
      submitButtonProps: t4,
      chipsProps: t8,
      popoverProps: t9,
      list: t10,
      submitText: "\u062A\u0627\u06CC\u06CC\u062F",
      onChange
    };
    $[31] = onChange;
    $[32] = t10;
    $[33] = t4;
    $[34] = t8;
    $[35] = t9;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  return t11;
};